export const styles = (theme) => ({
  root: {
    flexGrow: 1,
    padding: 0,
  },
  paper: {
    textAlign: "left",
    color: theme.palette.text.secondary,
    marginLeft: 30,
    marginRight: 20,
    paddingBottom: 30,
  },
  smallerPaddingPaper: {
    textAlign: "left",
    color: theme.palette.text.secondary,
    marginLeft: 30,
    marginRight: 20,
    paddingBottom: 10,
  },
  block: {
    backgroundColor: "white",
  },
  rightButton: {
    marginLeft: "auto",
  },
  title: {
    textAlign: "center",
    width: "100%",
  },
  blockHeader: {
    backgroundColor: "#d7d3d3",
  },
  singleSelect: {
    marginLeft: 20,
    marginRight: 3,
  },
  inputBox: {
    marginLeft: 0,
    width: 150,
    textAlign: "left",
  },
  smallerHeader: {
    marginTop: 0,
    marginBottom: 5,
  },
  tabs: {
    marginTop: 10,
    marginBottom: 10,
  },
  calendar: {
    maxWidth: 140,
  },
  headerSpacing: {
    marginTop: 10,
    marginBottom: 10,
  },
  card: {
    textAlign: "left",
    color: theme.palette.text.secondary,
    minWidth: "70vw",
  },
  cardCareTeam: {
    marginLeft: 30,
    marginRight: 30,
    width: "75vw",
    textAlign: "left",
    color: theme.palette.text.secondary,
    borderWidth: 0,
  },
  spaceAroundContainer: {
    marginTop: 30,
  },
  newColor: {
    backgroundColor: "#FFC0CB",
  },
  fixedTabWidth: {
    width: "30%",
  },
  leftTabs: {
    minWidth: 170,
  },
  tabBackground: {
    backgroundColor: "#FFFFFF",
  },
  patientBox: {
    marginLeft: 30,
    width: "75vw",
  },
  encounterBox: {
    textAlign: "left",
    color: theme.palette.text.secondary,
    marginLeft: 30,
    marginRight: 20,
    paddingBottom: 30,
    width: "75vw",
  },
  inputBoxSpace: {
    marginLeft: 10,
  },
  SmallTableFixed: {
    width: 400,
  },
  fullBackground: {
    backgroundColor: "3355FF",
  },
  containerColor: {
    backgroundColor: "#3355FF",
  },

  dropdownColor: {
    background: "red !important",
  },
});
